<portal-loading-indicator [show]="saving" indicatorStyle="transparent"></portal-loading-indicator>

<portal-card class="portal-feature" [ngClass]="{ 'is-invalid': !valid }">
  <h2 header>
    <span>{{ 'feature.PHONE_BOOK_LOOKUP' | portalTranslate }}</span>
    <i
      class="far fa-fw fa-question-circle ms-1 tooltip-help"
      [portalTippy]="'feature.PHONE_BOOK_LOOKUP.info' | translate"
      placement="right"
    ></i>
  </h2>

  @if (allowDistribution) {
    <ng-container actions>
      <portal-dropdown-menu
        *portalIsAuthorized="{
          anyPermission: [Permission.MANAGE_USER_FEATURE_CONFIG, Permission.MANAGE_ANY_USER_FEATURE_CONFIG],
        }"
        placement="bottom-right"
      >
        <portal-link
          [params]="{ featureId: feature.id }"
          ngbDropdownItem
          route="end-user-feature-distribution"
        >
          {{ 'features.distribute.feature.settings.to.other.users' | translate }}
        </portal-link>
      </portal-dropdown-menu>
    </ng-container>
  }

  <form [formGroup]="form">
    <div class="text-end">
      <portal-switch-toggle
        (onValueChanged)="onChanged()"
        formControlName="active"
        size="small"
      ></portal-switch-toggle>
    </div>
    <!-- Allow editing  -->
    <ng-container *portalRequiredC5Version="'7.8'">
      <div class="form-check mt-2 mb-0">
        <input
          class="form-check-input"
          id="isCorporateEditAllowed"
          (change)="onChanged()"
          formControlName="isCorporateEditAllowed"
          name="isCorporateEditAllowed"
          type="checkbox"
        />

        <label class="form-check-label" for="isCorporateEditAllowed">
          {{ 'feature.PHONE_BOOK_LOOKUP.allowEditing' | translate }}
        </label>
      </div>
    </ng-container>
  </form>
</portal-card>
